import {Clock} from "@app/core/shared/domain/clock";

/**
 * Concrete implementation of the Clock interface that provides the current system time.
 */
export class SystemClock implements Clock {
    now(): Date {
        return new Date();
    }
}